import React from "react";
import { Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {
    backgroundColor: "#104D82",
    overflow: "hidden",
    position: "fixed",
    bottom: 0,
    width: "100%",
    height: "85px",
    zIndex: 2,
  },
  navButtonActive: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    height: "100%",
    width: "100%",
    textAlign: "center",
    backgroundColor: "#0f4675",
    color: "#ffffff",
  },
  navButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    height: "100%",
    width: "100%",
    textAlign: "center",
    color: "rgba(255, 255, 255, 0.70)",
  },
});

export default function MobileNav() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Grid container height="100%" alignItems="center">
        <Grid
          container
          item
          xs={3}
          height="100%"
          justifyContent="center"
          alignItems="center"
          borderRight="1.5px solid rgba(255, 255, 255, 0.50)"
        >
          <Link
            to="/profile/edit"
            className={
              window.location.pathname === "/profile/edit"
                ? styles.navButtonActive
                : styles.navButton
            }
          >
            {" "}
            <Typography>Company</Typography>
          </Link>
        </Grid>
        <Grid
          container
          item
          xs={3}
          height="100%"
          justifyContent="center"
          alignItems="center"
          borderRight="1.5px solid rgba(255, 255, 255, 0.50)"
        >
          <Link
            to="/profile/projects"
            className={
              window.location.pathname === "/profile/projects"
                ? styles.navButtonActive
                : styles.navButton
            }
          >
            {" "}
            <Typography>Projects</Typography>
          </Link>
        </Grid>
        <Grid
          container
          item
          xs={3}
          height="100%"
          justifyContent="center"
          alignItems="center"
          borderRight="1.5px solid rgba(255, 255, 255, 0.50)"
        >
          <Link
            to="/profile/users"
            className={
              window.location.pathname === "/profile/users"
                ? styles.navButtonActive
                : styles.navButton
            }
          >
            {" "}
            <Typography>Users</Typography>
          </Link>
        </Grid>
        <Grid
          container
          item
          xs={3}
          height="100%"
          justifyContent="center"
          alignItems="center"
        >
          <Link
            to="/profile/account"
            className={
              window.location.pathname === "/profile/account"
                ? styles.navButtonActive
                : styles.navButton
            }
          >
            {" "}
            <Typography>Settings</Typography>
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}
